export default __webpack_public_path__ + "static/c-500-f91b2e1cf9a504baf9630266a17cc1b2.jpg";